(function ($) {

  $('#float-cv-bnr__entry').click(function () {
    $(this).toggleClass('active');
  });
})(jQuery);
